import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    modalHeader: {
        display: "flex",
        alignItems: "center",
        padding: `${theme.spacing(4)} ${theme.spacing(6)}`,
        borderBottom: `1px solid ${theme.palette.border.select}`,
        fontSize: "18px",
        fontWeight: 400,
        fontFamily: "Open Sans",
        color: theme.palette.info.main,
    },
    modalBody: {
        padding: theme.spacing(6),
        display: "flex",
        flexDirection: "column",
    },
    question: {
        "&.MuiTypography-root": {
            fontFamily: "Open Sans",
            fontWeight: 400,
            fontSize: "16px",
        },
    },
    footer: {
        borderTop: `1px solid ${theme.palette.border.select}`,
        display: "flex",
        padding: `${theme.spacing(4)} ${theme.spacing(6)}`,
        gap: theme.spacing(4),
        justifyContent: "flex-end",
    },
    submitButton: {
        "&.MuiButton-root": {
            fontFamily: "Open Sans !important",
            fontSize: "12px !important",
            fontWeight: "700 !important",
        },
    },
    boxContainer: {
        width: "100%",
    },
    formContainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: theme.spacing(6),
        padding: `${theme.spacing(5)} ${theme.spacing(7.5)} 0`,
    },
    formLabel: {
        "&.MuiTypography-root": {
            fontFamily: "Open Sans",
            fontWeight: 700,
            fontSize: "12px",
            textTransform: "uppercase",
            color: theme.palette.primary.dark,
        },
        "&.MuiFormLabel-root": {
            fontFamily: "Open Sans",
            fontWeight: 700,
            fontSize: "12px",
            textTransform: "uppercase",
            color: theme.palette.primary.dark,
        },
        "&.MuiFormLabel-root.Mui-focused": {
            color: theme.palette.primary.dark,
        },
    },
    textField: {
        width: "100%",

        "& .MuiOutlinedInput-root": {
            fontFamily: "Open Sans",
            fontSize: "16px",
            fontWeight: "400",
            "& .MuiOutlinedInput-input": {
                fontFamily: "Open Sans",
                fontSize: "16px",
                fontWeight: "400",
                padding: `${theme.spacing(2.25)} ${theme.spacing(3)} !important`,
            },
            "&.Mui-focused fieldset": {
                borderColor: theme.palette.info.main,
            },
        },
        "& .MuiInputLabel-outlined": {
            fontFamily: "Open Sans",
            fontSize: "16px",
            fontWeight: "400",
            "&.Mui-focused": {
                color: theme.palette.info.light,
            },
        },
    },
    hmiModalHeader: {
        display: "flex",
        alignItems: "center",
        padding: `${theme.spacing(4)} ${theme.spacing(6)}`,
        fontSize: "20px",
        fontWeight: 600,
        fontFamily: "Open Sans",
        color: theme.palette.text.primary,
    },
    hmiModalBody: {
        padding: theme.spacing(6),
        display: "flex",
        flexDirection: "column",
    },
    hmiQuestion: {
        "&.MuiTypography-root": {
            fontFamily: "Open Sans",
            fontWeight: 400,
            fontSize: "16px",
            color: theme.palette.text.secondary,
        },
    },
    hmiFooter: {
        display: "flex",
        padding: `${theme.spacing(4)} ${theme.spacing(6)}`,
        gap: theme.spacing(3),
        justifyContent: "flex-end",
    },
    hmiSubmitButton: {
        color: theme.palette.text.primary + " !important",
        borderColor: theme.palette.text.primary + " !important",
        backgroundColor: "#F5FAFF !important",
        "&.MuiButton-root": {
            fontFamily: "Open Sans !important",
            fontSize: "14px !important",
            fontWeight: "600 !important",
            minWidth: "120px",
        },
    },
}));

export const modalStyles = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "592px",
    maxHeight: "calc(100vh - 32px)",
    overflowY: "auto",
    bgcolor: "background.paper",
    borderRadius: "4px",
};

export const hmiModalStyles = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "600px",
    maxHeight: "calc(100vh - 32px)",
    overflowY: "auto",
    bgcolor: "background.paper",
    borderRadius: "8px",
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
};
